import { DefaultButton } from "components/Shared/DefaultButton";
import { useReviewFixtureTask } from "hooks/useFixtureTaskApi";
import { useReviewSeasonTask } from "hooks/useSeasonTaskApi";
import { useIntl } from "react-intl";

type Props = {
  entityId: string;
  season?: any;
  fixture?: any;
};

export const ReviewButton = ({ entityId, season, fixture }: Props) => {
  const { formatMessage } = useIntl();
  const { mutate: reviewSeasonTask, isPending: isSeasonTaskStartReviewing } = useReviewSeasonTask();
  const { mutate: reviewFixtureTask, isPending: isFixtureTaskStartReviewing } = useReviewFixtureTask();

  const onReview = () => {
    if (fixture) {
      reviewFixtureTask({
        entityId: entityId,
        seasonId: fixture.seasonId,
        fixtureId: fixture.fixtureId,
      });
    } else if (season) {
      reviewSeasonTask({ entityId: entityId, seasonId: season.seasonId });
    }
  };

  return (
    <DefaultButton
      loading={isSeasonTaskStartReviewing || isFixtureTaskStartReviewing}
      onClick={onReview}
      icon={<i className="fa-solid fa-magnifying-glass"></i>}
    >
      {formatMessage({ id: "button.review" })}
    </DefaultButton>
  );
};
